/** VRHump's categories (from its own category list, 2026-10-27; ids are needed in the page address). "Top" is left out: it is a ranking, not a category. */
export const VRHUMP_CATEGORIES = [
  { id: "360", slug: "360_Degree", label: "360 Degree" },
  { id: "9", slug: "Anal_Sex", label: "Anal Sex" },
  { id: "24", slug: "Anime_Hentai", label: "Anime Hentai" },
  { id: "30", slug: "Asian", label: "Asian" },
  { id: "25", slug: "Babysitter", label: "Babysitter" },
  { id: "28", slug: "BBW", label: "BBW" },
  { id: "31", slug: "Big_Ass", label: "Big Ass" },
  { id: "15", slug: "Big_Dick", label: "Big Dick" },
  { id: "22", slug: "Big_Tits", label: "Big Tits" },
  { id: "3", slug: "Blowjobs", label: "Blowjobs" },
  { id: "23", slug: "Bondage_and_BDSM", label: "Bondage and BDSM" },
  { id: "35", slug: "College", label: "College" },
  { id: "27", slug: "Cosplay", label: "Cosplay" },
  { id: "17", slug: "Creampie", label: "Creampie" },
  { id: "34", slug: "Cumshots", label: "Cumshots" },
  { id: "18", slug: "Ebony", label: "Ebony" },
  { id: "39", slug: "Fetishes", label: "Fetishes" },
  { id: "7", slug: "For_Women", label: "For Women" },
  { id: "999", slug: "Full_Length_Videos", label: "Full Length Videos" },
  { id: "21", slug: "Gang_bang", label: "Gang bang" },
  { id: "10", slug: "Gay", label: "Gay" },
  { id: "33", slug: "Handjob", label: "Handjob" },
  { id: "4", slug: "Hardcore_Sex", label: "Hardcore Sex" },
  { id: "26", slug: "Interracial", label: "Interracial" },
  { id: "20", slug: "Japanese", label: "Japanese" },
  { id: "40", slug: "JOI", label: "JOI" },
  { id: "2", slug: "Lesbian", label: "Lesbian" },
  { id: "29", slug: "Massage", label: "Massage" },
  { id: "14", slug: "Mature", label: "Mature" },
  { id: "12", slug: "MILF", label: "MILF" },
  { id: "36", slug: "Parody", label: "Parody" },
  { id: "32", slug: "POV", label: "POV" },
  { id: "19", slug: "Public", label: "Public" },
  { id: "38", slug: "Redhead", label: "Redhead" },
  { id: "37", slug: "School", label: "School" },
  { id: "5", slug: "Solo", label: "Solo" },
  { id: "16", slug: "Squirting", label: "Squirting" },
  { id: "41", slug: "Striptease", label: "Striptease" },
  { id: "6", slug: "Teen", label: "Teen" },
  { id: "8", slug: "Threesomes", label: "Threesomes" },
  { id: "13", slug: "Trans", label: "Trans" },
  { id: "1", slug: "Video_Games", label: "Video Games" },
] as const
